import { usePermission } from '@/common/hooks/index';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './index.less';

/**
 *  国家医保局
 * @returns
 */
const MedicalInsurance: React.FC = () => {
  const navigate = useNavigate();
  const { permission } = usePermission();

  const itemLis = [
    {
      id: 1,
      label: '医保药品数据库(西药+中成药)',
      url: '/datamanagement/datalake/medicalInsurance/pcMedicine',
      root: 'medPcTable',
    },
    {
      id: 2,
      label: '医保药品数据库(中药饮片)',
      url: '/datamanagement/datalake/medicalInsurance/chineseMedicine',
      root: 'medCmTable',
    },
    {
      id: 3,
      label: '医保医用耗材数据库',
      url: '/datamanagement/datalake/medicalInsurance/consumables',
      root: 'medConsumTable',
    },
    {
      id: 4,
      label: '全国医疗服务项目',
      url: '/datamanagement/datalake/medicalInsurance/medicalService',
      root: 'medServiceTable',
    },
    {
      id: 5,
      label: '中医疾病医保 2.0 版',
      url: '/datamanagement/datalake/medicalInsurance/tcmDiseases',
      root: 'medTcmDiseases',
    },
    {
      id: 6,
      label: '中医证候医保 2.0 版',
      url: '/datamanagement/datalake/medicalInsurance/tcmSyndrome',
      root: 'medTcmSyndrome',
    },
    {
      id: 7,
      label: '西医疾病 ICD-10 医保 2.0 版',
      url: '/datamanagement/datalake/medicalInsurance/surgeryIcd10',
      root: 'medIcd10Tree',
    },
    {
      id: 8,
      label: '西医手术 ICD-9-CM3 医保 2.0 版',
      url: '/datamanagement/datalake/medicalInsurance/surgeryIcd9',
      root: 'medIcd9Tree',
    },
  ];

  return (
    <div className={styles.inter}>
      <div className={styles.title}>医保局数据库版块</div>
      <div className={styles.container}>
        {itemLis.map((el) =>
          permission[el.root] ? (
            <div key={el.id} className={styles.item} onClick={() => navigate(el.url)}>
              <div className={styles.header}>
                <span className={styles.idx}>{el.id}</span>
                <span className={styles.name}>{el.label}</span>
              </div>
              <div className={styles.database}>查看数据库</div>
            </div>
          ) : null,
        )}
      </div>
    </div>
  );
};

export default MedicalInsurance;
